export default{
  customService:{
    Button:{
      lookDetail:"点击查看"
    },
    custom:{
      title:"海关服务",
    },
    service01:{
      title:"数字化助力全球农业服务贸易畅通",
      desc:"全球商通中心海关服务版块依托自身的政策优势，正在联动多方资源共同构建农业服务贸易数字通关新体系，逐步形成农产品电子预检机制、智能化关税政策匹配体系、跨境农贸多币种信用监管体系，并计划建立全球主要农产品输出国绿色通道，助力打造高效合规的国际农产品贸易服务体系。",
      list:[
        {name:"农产通检快车道",descList:["• 农产品进出口电子检验检疫系统","• 鲜活产品快速通关专班","• 成员国绿色通道"]},
        {name:"惠农税政专窗",descList:["• 关税减免政策智能匹配",'• 跨境涉农补贴"一键申报"入口',"• 农业中间品进料加工手册备案"]},
        {name:"跨境结算枢纽",descList:["• 农产品出口专项外汇结算通道","• 多币种信用证电子化审验","• 大宗农产品金融服务"]},
      ]
    },
    service02:{
      title:"海关服务一键直达",
      list:[
        {name:"综合服务",desc:"一站掌握最新政策法规，智能通关实时追踪，整合跨部门数据互联及风险预警，搭配专家智库支持全球贸易策略优化，赋能企业安全高效出海。"},
        {name:"线上服务",desc:'智慧通关系统 "互联网+海关"——业务在线办结（报关/缴税/核销），进度实时追踪，政策动态精准推送，打造全流程无纸化服务体系。'},
        {name:"国际贸易服务",desc:'整合申报、查验、缴税等全流程服务，一键提交多部门共享数据，智能追踪实时反馈，助力企业降本增效，实现跨境贸易“一网通办、全程无忧”。'},
        {name:"属地服务",desc:"属地海关服务，联自贸创新区与口岸枢纽，集成智能通关、检疫监管等核心服务链，打造一站式跨境解决方案，降本增效助推外贸升级。"},
      ]
    },
    service03:{
      title:"高效监管，优质体验！",
      list:[
        {name:"高效通关",desc:"通过运用先进技术和优化作业流程，实现快速、准确的通关服务，降低了企业的运营成本和时间成本。"},
        {name:"严格监管",desc:'确保进出口活动的合法性和安全性，有效打击走私等违法行为，维护了公平、有序的市场环境。'},
        {name:"优质服务",desc:'提供多元化、个性化的服务，满足企业的不同需求，提高了企业的满意度和忠诚度。'},
        {name:"数据支持",desc:"提供准确、及时的海关数据，为企业决策和政府管理提供了科学依据。"},
        {name:"政策引导",desc:"积极宣传和执行国家贸易政策，帮助企业享受政策红利，促进国际贸易的健康发展。"},
        {name:"国际合作",desc:"加强与其他国家和地区海关的合作，推动国际贸易自由化和便利化，为全球经济一体化做出贡献。"},
      ]
    },
    
  }
  
}